import { useCookieConsent } from "./useCookieConsent";

type UseConsentBannerVisibilityReturn = {
  readonly isVisible: boolean;
};

export const useConsentBannerVisibility =
  (): UseConsentBannerVisibilityReturn => {
    const { hasDecision } = useCookieConsent();

    return {
      isVisible: !hasDecision
    };
  };
